if (!customElements.get('dt-gift-films')) {
  customElements.define('dt-gift-films', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const video = this.querySelector('video');
      const toggle = this.querySelector('.dt-gift-play');
      const sync = () => {
        this.toggleAttribute('data-playing', !video.paused);
        toggle.setAttribute('aria-label', 'Play video');
      };
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      }, options);
      const controls = (show) => {
        video.controls = show;
        this.toggleAttribute('data-controls', show);
      };
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') controls(true);
      }, options);
      this.addEventListener('pointerleave', () => controls(false), options);
      video.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') controls(true);
      }, options);
      this.addEventListener('focusin', () => controls(true), options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) controls(false);
      }, options);
      video.addEventListener('play', sync, options);
      video.addEventListener('pause', sync, options);
      sync();
      const films = JSON.parse(this.querySelector('[data-film-sources]').textContent);
      let index = 0;
      let userPaused = this.hasAttribute('manual-play') || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
      let visible = true;
      let switching = false;
      const play = () => {
        if (!userPaused && visible && !document.hidden) video.play().catch(() => {});
      };
      const select = (next) => {
        const sources = (films[next] || []).filter(source => source.mime_type === 'video/mp4' || source.format === 'mp4');
        if (!sources.length) return;
        const target = navigator.connection?.saveData ? 640 : innerWidth < 750 ? 960 : 1920;
        sources.sort((a, b) => a.width - b.width);
        const source = sources.find(source => source.width >= target) || sources.at(-1);
        switching = true;
        index = next;
        video.src = source.url;
        video.load();
        play();
      };
      video.addEventListener('ended', () => select((index + 1) % films.length), options);
      video.addEventListener('loadeddata', () => { switching = false; }, options);
      video.addEventListener('play', () => { userPaused = false; }, options);
      video.addEventListener('pause', () => {
        if (visible && !document.hidden && !video.ended && !switching) userPaused = true;
      }, options);
      document.addEventListener('visibilitychange', () => document.hidden ? video.pause() : play(), options);
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play();
        else video.pause();
      });
      this.observer.observe(this);
      select(0);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
